import type { ReactNode } from 'react';
import { MobileBottomSheet } from './MobileBottomSheet';

interface MobileMapOverlayProps {
  map: ReactNode;
  onClose: () => void;
  /** Bottom-sheet content: the page's result cards. */
  children: ReactNode;
}

/**
 * Full-screen map overlay shown on narrow screens, with the page's result
 * cards in a bottom sheet over the map. Shared by Wineries, Experiences, and
 * Events; each page supplies its own cards.
 */
export const MobileMapOverlay = ({ map, onClose, children }: MobileMapOverlayProps) => (
  <div className="fixed inset-0 z-50 lg:hidden">
    {/* Map fills the screen */}
    <div className="absolute inset-0">{map}</div>

    {/* Close / back-to-list button */}
    <button
      type="button"
      onClick={onClose}
      className="absolute top-4 left-4 z-20 inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-gray-700 bg-gray-50 rounded-lg shadow-md hover:bg-gray-50 transition-colors"
    >
      <svg
        className="w-4 h-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
      List
    </button>

    <MobileBottomSheet>{children}</MobileBottomSheet>
  </div>
);
